/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import ExampleLoading from 'react-scale/components/website/index/Products/examples/exampleLoading';

const TaskResponseAnnotation = dynamic(
  () => import('react-scale/components/website/index/Products/examples/tasks/annotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

const response = {
  annotations: [
    {
      width: 119,
      height: 551,
      left: 53,
      top: 164,
      label: 'sign'
    },
    {
      width: 126,
      height: 584,
      left: 147,
      top: 268,
      label: 'sign'
    },
    {
      width: 123,
      height: 607,
      left: 349,
      top: 252,
      label: 'sign'
    },
    {
      width: 136,
      height: 647,
      left: 385,
      top: 247,
      label: 'sign'
    },
    {
      width: 122,
      height: 614,
      left: 427,
      top: 312,
      label: 'sign'
    },
    {
      width: 108,
      height: 548,
      left: 479,
      top: 392,
      label: 'sign'
    },
    {
      width: 94,
      height: 327,
      left: 524,
      top: 575,
      label: 'sign'
    },
    {
      width: 80,
      height: 324,
      left: 665,
      top: 595,
      label: 'sign'
    },
    {
      width: 48,
      height: 329,
      left: 812,
      top: 623,
      label: 'sign'
    },
    {
      width: 22,
      height: 131,
      left: 998,
      top: 859,
      label: 'sign'
    },
    {
      width: 31,
      height: 140,
      left: 1016,
      top: 828,
      label: 'sign'
    },
    {
      width: 29,
      height: 169,
      left: 1056,
      top: 836,
      label: 'sign'
    },
    {
      width: 53,
      height: 117,
      left: 1604,
      top: 983,
      label: 'sign'
    }
  ]
};

export default () => (
  <TaskResponseAnnotation
    hover
    imageURL="/static/img/website/solutions/self-driving-cars/slider/slide-3.jpg"
    annotations={response.annotations}
    bgTransparent
    responsive
    rounded
  />
);
